import { render, staticRenderFns } from "./detailKeywordSale.vue?vue&type=template&id=328d8114"
import script from "./detailKeywordSale.vue?vue&type=script&lang=js"
export * from "./detailKeywordSale.vue?vue&type=script&lang=js"
import style0 from "./detailKeywordSale.vue?vue&type=style&index=0&id=328d8114&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports